import { render, staticRenderFns } from "./OrderBinTable.vue?vue&type=template&id=3431a562&scoped=true"
import script from "./OrderBinTable.vue?vue&type=script&lang=js"
export * from "./OrderBinTable.vue?vue&type=script&lang=js"
import style0 from "./OrderBinTable.vue?vue&type=style&index=0&id=3431a562&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3431a562",
  null
  
)

export default component.exports